<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <form @submit.prevent="saveSetting()">
      <div class="row" data-tour="event-settings">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-12">
                  <label for="name">Nome do Evento</label>
                  <input
                    id="name"
                    name="name"
                    v-model="setting.name"
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.setting.name.$error,
                    }"
                    placeholder="Informe o nome do evento"
                  />
                  <div
                    v-if="submitted && !$v.setting.name.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-sm-4">
                  <label for="type_event">Tipo de evento</label>
                  <select
                    class="custom-select"
                    name="type_event"
                    id="type_event"
                    v-model="setting.type_event"
                    :class="{
                      'is-invalid': submitted && $v.setting.type_event.$error,
                    }">
                      <option value=""></option>
                      <option value="1">Evento gratuito</option>
                      <option value="2">Evento pago</option>
                  </select>
                  <div
                    v-if="submitted && !$v.setting.type_event.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
                <div class="col-sm-4">
                  <label for="event_init_date">Data início do evento</label>
                  <date-picker
                    v-model="setting.event_init_date"
                    type="datetime"
                    :first-day-of-week="1"
                    lang="pt-br"
                    format="DD/MM/YYYY HH:mm"
                    name="event_init_date"
                  >
                  </date-picker>
                </div>
                <div class="col-sm-4">
                  <label for="event_end_date">Data terminio do evento</label>
                  <date-picker
                    v-model="setting.event_end_date"
                    type="datetime"
                    :first-day-of-week="1"
                    lang="pt-br"
                    name="event_end_date"
                    format="DD/MM/YYYY HH:mm"
                  >
                  </date-picker>
                </div>
              </div>

              <!-- MODO DO EVENTO, BOTÃO LEMBRETE E ABERTURA DAS INSCRIÇÕES -->
              <div class="row mt-3">
                <div class="col-sm-4">
                  <label for="event_mode">Modo do Evento</label>
                  <select
                    class="custom-select"
                    name="event_mode"
                    id="event_mode"
                    v-model="setting.event_mode"
                  >
                    <option value="">Selecione...</option>
                    <option value="presencial">Presencial</option>
                    <option value="online">Online</option>
                    <option value="hibrido">Híbrido</option>
                  </select>
                  <small class="text-muted d-block mt-1">
                    Define como o evento será realizado
                  </small>
                </div>
                <div class="col-sm-4">
                  <label for="has_reminder_button">Botão de Lembrete</label>
                  <select
                    class="custom-select"
                    name="has_reminder_button"
                    id="has_reminder_button"
                    v-model="setting.has_reminder_button"
                  >
                    <option :value="true">Exibir</option>
                    <option :value="false">Não exibir</option>
                  </select>
                  <small class="text-muted d-block mt-1">
                    Permite que visitantes adicionem o evento ao calendário
                  </small>
                </div>
                <div class="col-sm-4">
                  <label for="registration_opens_at">Data de abertura das inscrições</label>
                  <date-picker
                    v-model="setting.registration_opens_at"
                    type="datetime"
                    :first-day-of-week="1"
                    lang="pt-br"
                    format="DD/MM/YYYY HH:mm"
                    name="registration_opens_at"
                    placeholder="Opcional"
                  >
                  </date-picker>
                  <small class="text-muted d-block mt-1">
                    Opcional. Bloqueia o formulário com contagem regressiva até essa data/hora.
                  </small>
                </div>
              </div>

              <!-- ENDEREÇO E LOCAL -->
              <div class="row mt-3">
                <div class="col-sm-6">
                  <div style="display: flex;justify-content: space-between;">
                    <label for="address_complete">Endereço do evento</label>
                    <b-form-checkbox v-model="setting.address_undefined" switch @change="toggleAddress">Não definido</b-form-checkbox>
                  </div>
                  <div class="input-group">
                    <input
                      id="address_complete"
                      name="address_complete"
                      v-model="setting.address_complete"
                      type="text"
                      class="form-control"
                      placeholder="Informe o endereço completo do evento"
                      :disabled="setting.address_undefined"
                      @keyup.enter="generateMapEmbed"
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-outline-primary"
                        type="button"
                        @click="generateMapEmbed"
                        :disabled="setting.address_undefined || !setting.address_complete"
                      >
                        <i class="mdi mdi-map-search"></i> Buscar Mapa
                      </button>
                    </div>
                  </div>
                  <small class="text-muted d-block mt-1">
                    Preencha o endereço e clique em "Buscar Mapa"
                  </small>
                </div>
                <div class="col-sm-6">
                  <div style="display: flex;justify-content: space-between;">
                  <label for="name_local">Nome do local</label>
                    <b-form-checkbox v-model="setting.local_undefined" switch @change="toggleLocal">Não definido</b-form-checkbox>
                  </div>
                  <input
                    id="local_name"
                    name="local_name"
                    v-model="setting.local_name"
                    type="text"
                    class="form-control"
                    placeholder="Informe o nome do local do evento"
                    :disabled="setting.local_undefined"
                  />
                </div>
              </div>

              <!-- PREVIEW DO MAPA -->
              <div class="row mt-3" v-if="setting.map_embed_url && !setting.address_undefined">
                <div class="col-sm-12">
                  <label>Pré-visualização do Mapa</label>
                  <div style="border: 1px solid #ced4da; border-radius: 4px; overflow: hidden;">
                    <iframe
                      :src="setting.map_embed_url"
                      width="100%"
                      height="250"
                      style="border:0; display:block;"
                      allowfullscreen
                      loading="lazy"
                      referrerpolicy="no-referrer-when-downgrade"
                    ></iframe>
                  </div>
                  <small class="text-muted d-block mt-1">
                    O mapa é gerado automaticamente a partir do endereço. Se quiser usar uma URL personalizada do Google Maps, edite o campo abaixo.
                  </small>
                  <div class="mt-2">
                    <a href="#" class="text-primary small" @click.prevent="showMapUrlField = !showMapUrlField">
                      <i class="mdi" :class="showMapUrlField ? 'mdi-chevron-up' : 'mdi-pencil'"></i>
                      {{ showMapUrlField ? 'Ocultar URL' : 'Editar URL manualmente' }}
                    </a>
                    <input
                      v-if="showMapUrlField"
                      v-model="setting.map_embed_url"
                      type="text"
                      class="form-control form-control-sm mt-1"
                      placeholder="https://www.google.com/maps/embed?pb=..."
                    />
                  </div>
                </div>
              </div>

              <!-- DESCRIÇÃO -->
              <div class="row mt-3">
                <div class="col-sm-12">
                  <label for="description">Descrição do Evento</label>
                  <ckeditor
                    :editor="editor"
                    v-model="setting.description"
                    :config="editorConfig"
                    :class="{
                      'is-invalid': submitted && $v.setting.description.$error,
                    }"
                  >
                  </ckeditor>
                  <div
                    v-if="submitted && !$v.setting.description.required"
                    class="invalid-feedback"
                  >
                  O campo é obrigatório
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Organização do evento</h4>
              <div class="row">
                <div class="col-sm-12">
                  <label for="organizer">Organizador</label>
                  <input
                    id="organizer"
                    name="organizer"
                    v-model="setting.organizer"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-sm-6">
                  <label for="contact_email">E-mail de Suporte</label>
                  <input
                    id="contact_email"
                    name="contact_email"
                    v-model="setting.contact_email"
                    type="text"
                    class="form-control"
                    placeholder="Informe um e-mail para Suporte"
                  />
                </div>
                <div class="col-sm-6">
                  <label for="contact_phone">Telefone de Suporte</label>
                  <input
                    id="contact_phone"
                    name="contact_phone"
                    v-model="setting.contact_phone"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Rodapé</h4>
              <p class="text-muted mb-4">Configure os links e informações que aparecerão no rodapé da landing page.</p>
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="footer_instagram">
                      <i class="bx bxl-instagram mr-1"></i> Instagram
                    </label>
                    <input
                      id="footer_instagram"
                      v-model="setting.footer_instagram"
                      type="url"
                      class="form-control"
                      placeholder="https://instagram.com/seuperfil"
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="footer_youtube">
                      <i class="bx bxl-youtube mr-1"></i> YouTube
                    </label>
                    <input
                      id="footer_youtube"
                      v-model="setting.footer_youtube"
                      type="url"
                      class="form-control"
                      placeholder="https://youtube.com/@seucanal"
                    />
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="footer_website">
                      <i class="bx bx-globe mr-1"></i> Website
                    </label>
                    <input
                      id="footer_website"
                      v-model="setting.footer_website"
                      type="url"
                      class="form-control"
                      placeholder="https://seusite.com.br"
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for="footer_contact_email">
                      <i class="bx bx-envelope mr-1"></i> Contato
                    </label>
                    <input
                      id="footer_contact_email"
                      v-model="setting.footer_contact_email"
                      type="email"
                      class="form-control"
                      placeholder="contato@seuemail.com"
                    />
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label for="footer_about">
                      <i class="bx bx-info-circle mr-1"></i> Sobre
                    </label>
                    <input
                      id="footer_about"
                      v-model="setting.footer_about"
                      type="url"
                      class="form-control"
                      placeholder="https://seusite.com.br/sobre"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Suporte WhatsApp -->
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-3"><i class="bx bxl-whatsapp mr-1" style="color: #25D366;"></i> Suporte WhatsApp</h4>
          <p class="text-muted font-size-13 mb-3">Exibe um botao flutuante de WhatsApp na landing page do evento para os participantes entrarem em contato.</p>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label>Numero do WhatsApp</label>
                <input
                  :value="waPhoneFormatted"
                  type="tel"
                  class="form-control"
                  placeholder="+55 (11) 99999-9999"
                  @input="onWaPhoneInput($event)"
                />
                <small class="text-muted">Deixe vazio para desativar o botao na landing page.</small>
              </div>
            </div>
            <div class="col-sm-6" v-if="waPhone">
              <div class="form-group">
                <label>Preview do link</label>
                <div class="d-flex align-items-center" style="gap: 8px;">
                  <a :href="'https://wa.me/' + waPhone" target="_blank" class="btn btn-sm btn-success">
                    <i class="bx bxl-whatsapp mr-1"></i> wa.me/{{ waPhone }}
                  </a>
                  <span class="badge badge-soft-success">Ativo</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="float-right">
            <button type="buton" @click="cancelar()" class="btn btn-dark mr-4">
              Cancelar
            </button>
            <button type="submit" class="btn btn-primary mr-1">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </form>
  </Layout>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import CKEditor from '@ckeditor/ckeditor5-vue'
import FullEditor from 'ckeditor5-build-full'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    ckeditor: CKEditor.component,
    Layout,
    DatePicker,
    PageHeader
  },
  name: 'setting-event',
  page: {
    title: 'Detalhes do evento',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      editor: FullEditor,
      editorConfig: {
        toolbar: {
          items: [
            'heading', '|',
            'bold', 'italic', 'underline', 'strikethrough', '|',
            'fontSize', 'fontColor', 'fontBackgroundColor', '|',
            'alignment', '|',
            'bulletedList', 'numberedList', '|',
            'outdent', 'indent', '|',
            'link', 'blockQuote', 'insertTable', 'horizontalLine', '|',
            'undo', 'redo'
          ],
          shouldNotGroupWhenFull: true
        },
        heading: {
          options: [
            { model: 'paragraph', title: 'Parágrafo', class: 'ck-heading_paragraph' },
            { model: 'heading2', view: 'h2', title: 'Título', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Subtítulo', class: 'ck-heading_heading3' }
          ]
        },
        fontSize: {
          options: ['tiny', 'small', 'default', 'big', 'huge']
        },
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
        }
      },
      loading: true,
      submitted: false,
      configEvent: false,
      showMapUrlField: false,
      setting: {},
      title: 'Detalhes do evento',
      items: [{
        text: 'Configurações gerais',
        href: '/settings'
      },
      {
        text: 'Detalhes do evento',
        active: true
      }
      ]
    }
  },
  validations: {
    setting: {
      name: { required },
      type_event: { required },
      description: { required }
    }
  },
  mounted () {
    let loader = this.$loading.show()
    this.GetSetting().then(() => {
      this.setting = this.data
      this.setting.event_init_date = this.$moment(this.setting.event_init_date, 'YYYY-MM-DD HH:mm').toDate()
      this.setting.event_end_date = this.$moment(this.setting.event_end_date, 'YYYY-MM-DD HH:mm').toDate()
      // Data de abertura das inscrições é opcional — só converte se houver valor
      this.setting.registration_opens_at = this.setting.registration_opens_at
        ? this.$moment(this.setting.registration_opens_at, 'YYYY-MM-DD HH:mm').toDate()
        : null
      // Inicializar flags se não existirem
      if (this.setting.address_undefined === undefined) {
        this.setting.address_undefined = false
      }
      if (this.setting.local_undefined === undefined) {
        this.setting.local_undefined = false
      }
      // Inicializar event_mode se não existir
      if (!this.setting.event_mode) {
        this.setting.event_mode = 'presencial'
      }
      // Inicializar has_reminder_button se não existir
      if (this.setting.has_reminder_button === undefined) {
        this.setting.has_reminder_button = true
      }
      // Sanitizar WhatsApp (0, false, "0" → null)
      console.log('[WA-DEBUG] before sanitize:', this.setting.support_whatsapp, typeof this.setting.support_whatsapp)
      this.sanitizeWhatsApp()
      console.log('[WA-DEBUG] after sanitize:', this.setting.support_whatsapp)
      console.log('[WA-DEBUG] waPhone computed:', this.waPhone)
      // Auto-gerar mapa se tem endereço mas não tem URL de embed
      if (this.setting.address_complete && !this.setting.map_embed_url && !this.setting.address_undefined) {
        this.generateMapEmbed()
      }
      loader.hide()
    })
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('settingEvent', { data: 'setting' }),
    waPhone: function () {
      var val = this.setting && this.setting.support_whatsapp
      if (!val || val === false || val === 0 || val === '0') return ''
      return String(val).replace(/\D/g, '')
    },
    waPhoneFormatted: function () {
      var d = this.waPhone
      if (!d) return ''
      if (d.length <= 2) return '+' + d
      if (d.length <= 4) return '+' + d.slice(0, 2) + ' (' + d.slice(2)
      if (d.length <= 9) return '+' + d.slice(0, 2) + ' (' + d.slice(2, 4) + ') ' + d.slice(4)
      if (d.length <= 12) return '+' + d.slice(0, 2) + ' (' + d.slice(2, 4) + ') ' + d.slice(4, 9) + '-' + d.slice(9)
      return '+' + d.slice(0, 2) + ' (' + d.slice(2, 4) + ') ' + d.slice(4, 9) + '-' + d.slice(9, 13)
    }
  },
  methods: {
    ...mapActions('settingEvent', {
      GetSetting: 'GetSetting',
      postSetting: 'SaveSetting'
    }),
    cleanPhone (val) {
      if (!val) return ''
      return String(val).replace(/\D/g, '')
    },
    onWaPhoneInput (e) {
      const raw = e.target.value.replace(/\D/g, '').slice(0, 13)
      this.$set(this.setting, 'support_whatsapp', raw || null)
    },
    sanitizeWhatsApp () {
      const val = this.setting.support_whatsapp
      if (!val || val === false || val === 0 || val === '0') {
        this.setting.support_whatsapp = null
      }
    },
    toggleAddress () {
      if (this.setting.address_undefined) {
        this.setting.address_complete = null
        this.setting.map_embed_url = null
      }
    },
    toggleLocal () {
      if (this.setting.local_undefined) {
        this.setting.local_name = null
      }
    },
    generateMapEmbed () {
      if (!this.setting.address_complete || this.setting.address_undefined) {
        return
      }
      const encodedAddress = encodeURIComponent(this.setting.address_complete)
      this.$set(this.setting, 'map_embed_url', `https://maps.google.com/maps?q=${encodedAddress}&output=embed`)
    },
    initSetting () {
      this.configEvent = true
    },
    async saveSetting () {
      this.submitted = true
      this.$v.setting.$touch()
      if (this.$v.setting.$invalid) {
        window.scroll(0, 0)
        return
      }
      let loader = this.$loading.show()
      try {
        const payload = {
          ...this.setting,
          event_init_date: this.setting.event_init_date
            ? this.$moment(this.setting.event_init_date).format('YYYY-MM-DD HH:mm:ss')
            : null,
          event_end_date: this.setting.event_end_date
            ? this.$moment(this.setting.event_end_date).format('YYYY-MM-DD HH:mm:ss')
            : null,
          registration_opens_at: this.setting.registration_opens_at
            ? this.$moment(this.setting.registration_opens_at).format('YYYY-MM-DD HH:mm:ss')
            : null,
          address_complete: this.setting.address_undefined ? null : this.setting.address_complete,
          map_embed_url: this.setting.address_undefined ? null : this.setting.map_embed_url,
          local_name: this.setting.local_undefined ? null : this.setting.local_name
        }
        await this.postSetting(payload).then(() => {
          let message = 'Sucesso: Dados atualizados com sucesso.'
          let delay = 2500
          successMessage(message, delay)
          loader.hide()
        })
      } catch (err) {
        loader.hide()
        errorMessage('Alerta: ' + err.response.data.message)
      }
    }
  }
}
</script>
<style>
.nav-pills .nav-link { border-radius: 0 !important; }
.checkout-tabs .nav-pills .nav-link{
  margin-bottom: 0 !important;
  text-align: left !important;
}
.link { cursor: pointer; }
.preview-lg {
  width: 100%;
  height: calc(372px * (9 / 16));
  overflow: hidden;
}
.logo-preview {
  width:200px;
  overflow:hidden;
  height: 65px;
}
.actions {
  margin-top: 1rem;
}
.actions a {
  display: inline-block;
  padding: 5px 15px;
  background: #0062CC;
  color: white;
  text-decoration: none;
  border-radius: 3px;
  margin-right: 1rem;
  margin-bottom: 1rem;
}
.bg-black { background-color: #afafaf; opacity: 1; }
.border-dashed {
  border: 2px dashed #ced4da !important;
  padding: 4px;
}
.box-qrcode {
  display: flex;
  padding: 5px 10px;
}
.badge-preview-label {
  padding: 0 !important;
  text-align: center;
  overflow: visible;
  outline: 1px dotted;
}
.qrcode {
  float:left;
  margin-left: 10px;
}
.number-qrcode {
  font-size: 18px;
  font-weight: bold;
  margin-top: -12px;
}
.info-label-default {
  text-align: left;
  margin-left: 20px;
  margin-top: 44px;
}
.info-label-model2 {
  display: block;
  text-align: left;
  margin-left: 20px;
  margin-top: 10px;
}
.name-participant-qrcode {
  display: block;
  line-height: 1.1em;
  font-size: 22px;
  font-weight: bold;
}
.name-participant-noqrcode {
  display: block;
  line-height: 1em;
  font-size: 22px;
  padding-top: 30px;
  font-weight: bold;
}
.text2-noqrcode {
  display: block;
  margin-bottom: -5px;
  font-size: 18px !important;
}
.text2-qrcode {
  display: block;
  font-size: 18px;
  margin-bottom: -5px;
  margin-top: 5px;
}
.text3-qrcode {
  display: block;
  margin-top: 6px;
  margin-bottom: -5px;
  font-size: 18px;
}
.text4-qrcode {
  display: block;
  margin-bottom: -5px;
  margin-top: 6px;
  font-size: 18px;
}

.mdi-spin {
  animation: mdi-spin 1s infinite linear;
}

@keyframes mdi-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
